<!--接口管理-->
<template>
  <div style="position: relative" class="content">
    <packageTable
      ref="contentBaseRef"
      :tableData="tableData"
      :columnsData="columnsData"
      :loading="tableLoading"
      :tabletotallen="tabletotallen"
      :reduceheight="reduceheight"
      :border="border"
      :stripe="stripe"
      :showSearchBtn="false"
      :tablePageSize="reqBase.page_size"
      @pageonChange="pageonChange"
      @pageSizeChange="pageSizeChange"
      @showSearchParel="showSearchParel"
      @refreshBtn="init"
    >
      <template slot="headRight">
        <Tooltip
          v-for="(item, index) in headBtnList1"
          :key="index"
          :content="item.name"
          placement="bottom"
        >
          <Button
            :type="item.type"
            style="margin-right: 5px"
            @click="item.method"
            :key="index"
            :icon="item.icon"
          ></Button>
        </Tooltip>
      </template>
      <!-- <template slot="search">
        <Col span="6">
          <FormItem :label="this.$t('role_name')">
            <Input
              v-model="group_name"
              type="text"
              :placeholder="this.$t('role_name_input')"
            />
          </FormItem>
        </Col>
      </template> -->
      <!-- <template slot="searchOperation">
        <Col span="6">
          <Button
            v-for="(item, index) in topButtonList"
            :type="item.type"
            style="margin-right: 5px"
            :icon="item.icon"
            @click="item.method"
            :key="index"
            >{{ item.name }}</Button
          >
        </Col>
      </template> -->
    </packageTable>
  </div>
</template>

<script>
import packageTableMixins from "@/mixins/packageTableMixins.js";
// import {errorCode} from '@/config/errorCode'
import addRole from "./roleManCom/addRole";
import { getUserInfo } from "@/api/user";
import {
  addgroup,
  grouplist,
  delgroup,
  module_update,
  group_update,
  getgrouplist,
  groupPermission_config,
  getgroup_permission,
  default_role,
  getUserlist,
  addUserlist,
  openOroffUser,
  delUser,
  editUser
} from "@/api/auth";
import addRoleEdit from "./roleManCom/addRoleEdit";
export default {
  name: "interfaceManage",
  mixins: [packageTableMixins],
  data() {
    return {
      group_name: null,
      dingji: localStorage.getItem('is_dingji'),
      headBtnList1: [
        {
          method: this.add,
          type: "primary",
          icon: "ios-add",
          name: this.$t('新增'),
          key: "addgroup",
        },
        // {
        //   name: "刷新",
        //   icon: "ios-refresh",
        //   type: "primary",
        //   method: this.init,
        //   key: "grouplist",
        // },
      ],
      topButtonList: [
        {
          name: this.$t("query"),
          type: "primary",
          icon: "ios-search",
          method: this.okSearch,
        },
        {
          name: this.$t("reset"),
          type: "error",
          icon: "ios-refresh",
          method: this.resetSearch,
        },
      ],
      searchReq: {
        mods: [],
      },
      tableData: [],
      columnsData: [
        {
          title:this.$t('用户账号') ,
          key: "admin_name",
          align: "center",
        },
        {
          title: this.$t('用户名称'),
          key: "name",
          align: "center",
        },
          {
          title: this.$t('角色'),
          key: "group_names_str",
          align: "center",
        },
        {
          title: this.$t('创建时间'),
          key: "addtime",
          align: "center",
        },
        {
          title: this.$t('状态'),
          key: "status",
          align: "center",
            render: (h, { row }) => {
          let result = "";
          let color = "";
          if (row.status === 1) {
            result = this.$t("启用");
          }  else {
            result = this.$t("禁用");
          }
          return h(
            "span",
            result
          );
        },
        },
        {
          title:this.$t('操作') ,
          key: "explain",
          align: "center",
          width: 240,
          render: (h, { row }) => {
            let arr = [];

              arr.push(
                h(
                  "Button",
                  {
                    style: {
                      marginRight: "3px",
                      marginBottom: "3px",
                      color: "#2d8cf0",
                    },
                    props: {
                      size: "small",
                      type: "text",
                    },
                    on: {
                      click: () => {
                        this.roleEdit(row);
                      },
                    },
                  },
                  row.status==1? this.$t('禁用'):this.$t('启用')

                )
              );
              arr.push(
                h(
                  "Button",
                  {
                    style: {
                      marginRight: "3px",
                      marginBottom: "3px",
                      color: "#2d8cf0",
                    },
                    props: {
                      size: "small",
                      type: "text",
                    },
                    on: {
                      click: () => {
                        this.edit(row);
                      },
                    },
                  },
                 this.$t('编辑')
                )
              );
              arr.push(
                h(
                  "Button",
                  {
                    style: {
                      marginRight: "3px",
                      marginBottom: "3px",
                      color: "#2d8cf0",
                    },
                    props: {
                      size: "small",
                      type: "text",
                    },
                    on: {
                      click: () => {
                        this.delModule(row);
                      },
                    },
                  },
                  this.$t('删除')
                )
              );

            return h("div", arr);
          },
        },
      ],
      tableLoading: false,
      tabletotallen: 0,
      border: true,

      stripe: true,
      moduleShow: false,
      addBase: {
        name: "",
        code: "",
        state: "",
        explain: "",
      },
      reqBase: {
        page: 1,
      },
      states: [
        {
          value: 0,
          label: "禁用",
        },
        {
          value: 1,
          label: "启用",
        },
      ],
      modalTitle: true,
      ruleValidate: {
        name: [{ required: true, message: "请输入模块名", trigger: "blur" }],
        code: [
          { required: true, message: "请输入模块代码", trigger: "change" },
        ],
        explain: [{ required: true, message: "请输入说明", trigger: "blur" }],
        state: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
    };
  },
  components: {},
  computed: {
    modelList() {
      return this.$store.state.authCenter.ModuleData;
    },
  },
  methods: {
    init() {
      this.getPageSizeToStorage();
      this.getData();
    },
    /**
     * 权限配置
     * */
    roleEdit(row) {
        // openOroffUser()
      let vm = this;
      let config = {
        loading: true,
        title: this.$t('提示'),
        width: 400,
        content: this.$t('确定操作')+`<span style="color: #f60;">${row.name}</span>？`,
        onOk: function () {
          const _this = this;
          let params = row.user_code,
            callbak = (req) => {
              if (req.result === 0) {
                vm.$Message.success(vm.$t('操作成功！'));
                vm.$Modal.remove();
                vm.init();
              } else {
                _this.buttonLoading = false;
                vm.$Message.error(req.errorMsg);
              }
            };
          //删除接口
          openOroffUser({user_code:row.user_code}).then((res) => {
            callbak(res);
          });
        },
      };
      this.$Modal.confirm(config);

    },
    /**
     * 初始化数据
     */
    getData() {
      this.tableLoading = true;
      const vm = this;
      //;
      let callbak = (res) => {
        this.tableLoading = false;
        vm.tableData = [];
        if (res.result === 0) {
          console.log("我的角色管理数据", res.body.list);

          vm.tableData = res.body.list || [];
          vm.tabletotallen = res.body.total;
        } else {
          vm.tableData = [];
          this.$Message.error(res.errorMsg);
        }
      };
      getUserlist(this.reqBase).then((res) => {
        callbak(res);
      });
    },
    /**
     * 重置搜索框
     */
    resetSearch() {
      this.group_name = null;
      this.okSearch();
    },
    okSearch() {
      Object.assign(this.reqBase, this.searchReq);
      //重置当前页为1
      this.reqBase.page = 1;
      this.reqBase.group_name = this.group_name;
      this.$refs.contentBaseRef.initcurrentPage();
      this.init();
    },
    /**
     * 翻页
     */
    pageonChange(index) {
      this.addBase.page = index;
      this.getData();
    },
    /**
     * 筛选
     */
    showSearchParel() {
      this.$refs.search.expandPanel();
    },
    /**
     * 控制模态框显示隐藏
     * type 显示隐藏
     * handle true新增 false编辑
     * row 本条数据
     */
    add(type = false, handle, row) {
      let vm = this;
      let config = {
        loading: true,
        width: 600,
        okText:  this.$t('确定'),
        cancelText: this.$t('取消'),
        render: (h) => {
          return h("div", [
            h("h3", this.$t('新增用户')),
            h(addRole, {
              ref: "addRole",
              props: {
                edit: false,
                _vm: vm,
                type:'add'
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.addRole;
          obj.formCheck().then((res) => {
            if (res) {
              //提交请求
              let formModel = obj.formModel;
              addUserlist({
                ...formModel,
                menu_codes:[]
              }).then((res) => {
                if (res.result === 0) {
                  vm.$Message.success(vm.$t('添加成功！'));
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },
    edit(row) {
      console.log('rowrowrow',row);

      let vm = this;
      let config = {
        loading: true,
        width: 600,
        okText:this.$t('确定'),
        cancelText: this.$t('取消'),
        render: (h) => {
          return h("div", [
            h("h3", this.$t('编辑用户')),
            h(addRole, {
              ref: "addRole",
              props: {
                edit: true,
                _vm: vm,
                setData: row,
                 type:'edit'
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.addRole;
          obj.formCheck().then((res) => {
            if (res) {
              //提交请求
              let formModel = obj.formModel;
              editUser({
                ...formModel,
                menu_codes:[],
                group_codes:[formModel.group_codes],
                user_code:row.user_code
              }).then((res) => {
                if (res.result === 0) {
                  vm.$Message.success(vm.$t('修改成功！'));
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },
    /**
     * 编辑
     * modalTitle true新增  false编辑
     */
    editInit(row) {
      this.addBase = {
        name: row.name,
        code: row.code,
        state: row.state,
        explain: row.explain,
      };
    },
    //新增/编辑提交
    addModuleOk() {
      const _this = this;
      let title = _this.modalTitle ?this.$t('新增')  :this.$t('编辑') ;
      let params = _this.addBase,
        callbak = (req) => {
          if (req.status === 1) {
            this.$Message.success(`${title}:${req.msg}`);
          } else {
            this.$Message.error(`${title}:${req.msg}`);
          }
        };
      this.$refs.addmodal.validate((valid) => {
        if (valid) {
          if (_this.modalTitle) {
            //新增接口
          } else {
            //编辑接口
          }
        } else {
          this.$Message.error("请检查必填项");
        }
      });
    },
    /**
     * 删除
     */
    delModule(row) {
      let vm = this;
      let config = {
        loading: true,
        title: this.$t('删除'),
        width: 400,
        content: this.$t('删除')+`<span style="color: #f60;">${row.name}</span>？`,
        onOk: function () {
          const _this = this;
          let params = {
              id: row.id,
            },
            callbak = (req) => {
              if (req.result === 0) {
                vm.$Message.success(vm.$t('删除成功！'));
                vm.$Modal.remove();
                vm.init();
              } else {
                _this.buttonLoading = false;
                vm.$Message.error(req.errorMsg);
              }
            };
          //删除接口
          delUser({user_code:row.user_code}).then((res) => {
            callbak(res);
          });
        },
      };
      this.$Modal.confirm(config);
    },
  },
  mounted() {
    //获取相应权限

      this.getFunctionRole();
      console.log(this.functionRole);
      this.init();
  },
  created() {},
};
</script>

<style scoped>
.w6 {
  width: calc(25% - 10px);
  margin-left: 5px;
  margin-right: 5px;
}
.content {
  height: 100%;
  padding: 25px 10px 0;
}
</style>
